import React from 'react';

class JobLocations extends React.Component {
    constructor() {
        super();
        this.state = {
            toggle: false,

        }
    }

    render() {

        const {toggle} = this.state;

        const _toggle = toggle ? "item-uncollapsed" : "item-collapsed",
            label = toggle ? "less" : "more",
            faIcon = toggle ? "fa fa-angle-up" : "fa fa-angle-down";

        const {job} = this.props;

        const firstLocation = job.locations && (job.locations) [0].name;

        const lastLocations = job.locations && (job.locations ).slice(1);

        const hiddenLocationNames = lastLocations && lastLocations.map((location, index) => <li key={index}
                                                                               className="job-location">{location.name}</li>)

        return (
            <span className={`job-location-list-item ${ _toggle }`}>
                <div className="job-location-list"><p className="p-tag"><b>Location/s:</b></p></div>
                    <ul className="list-unstyled location-list item-content">
                        <li className="first-industry">
                            {firstLocation}
                        </li>
                        {hiddenLocationNames}
                    </ul>

                {(hiddenLocationNames && hiddenLocationNames.length > 0)

                    ? <div className="line">
                        <button className="btn btn-more-less" onClick={() => this.setState({toggle: !toggle})}>
                            <span className="label">{label}</span>
                            <span className="icon"><i className={`${ faIcon } fa-right`}/></span>
                        </button>
                    </div>
                    :
                    null
                }

            </span>
        )
    }
}

export default JobLocations;


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobLocations.js